import axios from 'axios';
let that = this
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params , vnode) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        dataType: 'json',
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res =>{
        if(res.status == 200){
            return res.data
        }
    }).catch(err=>{
        if(err.response.data.code == 401) {
            window.location.reload()
        }
        console.log(err.response.data)
        return err.response.data
    })
};


// 通用公用方法
const reqJson = (method, url, params , headers) => {
    return axios({
        method: method,
        url: url,
        headers: headers == 'headers'?{
            'Content-Type': 'application/json',
            token: localStorage.getItem('logintoken'),
            params:JSON.stringify(params)
        }:{
            'Content-Type': 'application/json',
            token: localStorage.getItem('logintoken'),
        },
        data: removeEmptyStrings(params),
        traditional: true,
    }).then(res =>{
        if(res.status == 200){
            return res.data
        }
    }).catch(err=>{
        if(err.response.data.code == 401) {
            window.location.reload()
        }
        console.log(err.response.data)
        return err.response.data
    })
};


function removeEmptyStrings(obj) {
    for (let key in obj) {
      if (obj[key] === '') {
        delete obj[key];
      }
    }
    return obj;
  }

export {
    loginreq,
    req,
    reqJson
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js